export default __webpack_public_path__ + "ad7a7403550946b65c085de20a9abe69.jpg";